import axios from 'axios';
import {url} from "../Values/constants";
import { useHistory } from 'react-router-dom';
import {handleLogout} from "./auth";
// Create an Axios instance
const axiosHandler = axios.create({
  baseURL: url, // Replace with your API base URL
});
let isLogoutCalled = false;
// Request Interceptor
axiosHandler.interceptors.request.use(
  config => {
    const user:any = localStorage.getItem('user'); // Get the user from local storage
    const parsedUser = JSON.parse(user);
    if (parsedUser?.token) {
      config.headers['x-access-token'] = parsedUser.token; // Attach the token to the request headers
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosHandler.interceptors.response.use(
  response => {
    if(response?.data?.statusCode === 401 && response?.data?.message === "Your readpro subscription has expired, Please contact your admin"){
      if(isLogoutCalled === false){
        handleLogout();
        alert("Your readpro subscription has expired, Please contact your admin")
      }
      isLogoutCalled = true;
    }
    else{
      return response;
    }
  },
  error => {
    if (error.response && error.response.status === 401) {
      if(isLogoutCalled === false){
        handleLogout();
      }
      isLogoutCalled = true;
    }
    if (error.response && error.response.status === 402) {
      if(isLogoutCalled === false){
        handleLogout();
      }
      isLogoutCalled = true;
    }
    return Promise.reject(error);
  }
);

export default axiosHandler;
